type LogsEventLike = {
  message?: string;
  status?: string;
  error?: { kind?: string; stack?: string };
  view?: { url?: string };
};

// 브라우저 정책상 발생하는 에러라 프론트 코드로 고칠 수 없다.
// NotAllowedError: autoplay 차단·알림 권한 거부 / AbortError: 요청 취소
const DROP_ERROR_KINDS = ['NotAllowedError', 'AbortError'];

const DROP_PATTERNS = [
  'antd: Modal',
  'useForm',
  'findDOMNode',
  'g/collect',
  // 브라우저가 리플로우 루프를 끊었다는 알림. 실제 동작에 영향이 없다.
  'ResizeObserver loop'
];

const WARN_PATTERNS = ['XHR error', 'Fetch error', 'AxiosError', 'Request failed with status code', 'Network Error'];

const AUTH_LIFECYCLE_MESSAGES = ['Token refresh failed', 'No access token to refresh'];

const beforeSendHandler = (log: LogsEventLike): boolean => {
  const { message, error } = log;
  const kind = error && error.kind;
  const isSevere = log.status === 'error' || log.status === 'warn';

  if (kind && DROP_ERROR_KINDS.indexOf(kind) !== -1) return false;

  if (kind === 'AuthError' && message && AUTH_LIFECYCLE_MESSAGES.some((m) => message.includes(m))) return false;

  if (!message || !message.trim()) {
    // 메시지도 스택도 없는 error/warn 은 조치할 수 없다(빈 인자 console.error).
    if (!(error && error.stack)) return !isSevere;
    // 스택이 있으면 메시지가 비어도 추적 가능하므로 남긴다. 메시지 기반 검사는 건너뛴다.
    return true;
  }

  if (DROP_PATTERNS.some((pattern) => message.includes(pattern))) return false;

  if (log.status === 'error' && WARN_PATTERNS.some((pattern) => message.includes(pattern))) {
    // 이벤트 객체 in-place 수정이 Datadog beforeSend 의 계약이다.
    // eslint-disable-next-line no-param-reassign
    log.status = 'warn';
  }
  return true;
};

export default beforeSendHandler;
